// export async function apiImportUsers(authToken, programId, periodId, users) {
//   const url = `${
//     import.meta.env.VITE_API_URL
//   }/v1/auth/register/batch/?programId=${programId}&periodId=${periodId}`
//   const res = await axios.post(
//     url,
//     { users },
//     {
//       headers: {
//         authorization: `Bearer ${authToken}`,
//       },
//     }
//   )
// }

import type {
  GetUserNotesDTOType,
  GetUserNotesResponseType,
  GetUsersDTOType,
  GetUsersResponseType,
  GetUsersSessionDTOType,
  ImportUsersDTOType,
  UpdateUserNotesDTOType,
} from '@/features/admin/users/types'
import fetchClient from '@/lib/fetch'

// Taille d'une tranche d'import. Un import de plusieurs milliers de lignes en
// une seule requête la gardait ouverte 5 minutes et faisait monter l'API à
// 1,4 Go (crash mémoire de ce-assas-api, 21/10/2026). Les tranches partent
// l'une après l'autre : l'interface ne change pas (un seul spinner, un seul
// toast), et une erreur arrête l'import comme avant.
export const IMPORT_USERS_CHUNK_SIZE = 200

export async function importAdminUsersMutation({ programId, users }: ImportUsersDTOType): Promise<any> {
  let lastResponse: any
  for (let i = 0; i < users.length; i += IMPORT_USERS_CHUNK_SIZE) {
    lastResponse = await fetchClient(`/v1/auth/register/batch`, {
      method: 'POST',
      body: JSON.stringify({ users: users.slice(i, i + IMPORT_USERS_CHUNK_SIZE), programId }),
    })
  }
  return lastResponse
}

export const USER_NOTE_QUERY_KEY = 'USER_NOTE_QUERY_KEY'
export function GetUserNotes(data: GetUserNotesDTOType): Promise<GetUserNotesResponseType> {
  return fetchClient(`/v1/user/notes/${data.userId}`, {
    method: 'GET',
  })
}

export function UpdateUserNotesMutation(data: UpdateUserNotesDTOType): Promise<any> {
  return fetchClient(`/v1/user/notes/`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export const USERS_QUERY_KEY = 'users'
export async function getUsers({
  programId,
  page,
  perPage,
  role,
  hasGroup,
  search,
  isCreatingGroup,
}: GetUsersDTOType): Promise<GetUsersResponseType> {
  return fetchClient(
    `/v1/user/all?programId=${programId}&page=${page}&perPage=${perPage}&role=${role}&search=${search}&hasGroup=${hasGroup}&isCreatingGroup=${isCreatingGroup}`,
    {
      method: 'GET',
    },
  )
}

export async function getUsersWithSession({
  programId,
  page,
  perPage,
  role,
  hasGroup,
  search,
}: GetUsersSessionDTOType): Promise<GetUsersResponseType> {
  return fetchClient(
    `/v1/user/all-with-session?programId=${programId}&page=${page}&perPage=${perPage}&role=${role}&search=${search}&hasGroup=${hasGroup}`,
    {
      method: 'GET',
    },
  )
}
